import React from "react";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { MONETIC_MARKS } from "@constants/index";

import { useMoneticsForm } from "../MoneticsFormContext";
import { FieldError } from "./FieldError";

const ALPHANUMERIC_REG_EXP = /^[a-zA-Z0-9]*$/;

/** "Designation" text input with its name / empty / alphanumeric errors. */
export function DesignationField() {
    const { form, props } = useMoneticsForm();
    const { t, designation, setDesignation, isNameExist, mark } = form;
    const {
        inputDesignation,
        setInputDesignation,
        isConsult,
        shopIds,
        setIsEdited,
    } = props;

    const isNameAlreadyTaken =
        (isNameExist && (shopIds === undefined || shopIds.length === 0)) ||
        (isNameExist && shopIds !== undefined && shopIds.length >= 1);
    const isDesignationEmpty =
        designation?.trim() === "" && designation !== "";
    const isNonAlphanumericYavin =
        designation !== "" &&
        !ALPHANUMERIC_REG_EXP.test(designation) &&
        mark === MONETIC_MARKS.YAVIN;

    return (
        <AvGroup>
            <StyledLabel htmlFor="text" className="required__clz mt-3 ">
                {t("Designation")}
            </StyledLabel>
            <StyledTextInput
                className={classnames("mnt_inp_name ", {
                    input__clz:
                        inputDesignation ||
                        isNameAlreadyTaken ||
                        isDesignationEmpty ||
                        isNonAlphanumericYavin,
                    readOnly__clz: isConsult,
                })}
                data-testid="monetics-designation-input"
                autocomplete="off"
                name="designation"
                onChange={(e: any) => {
                    setDesignation(e.target.value);
                    setIsEdited(true);
                    setInputDesignation(false);
                }}
                value={designation}
                placeholder={t("Write")}
                type="text"
                autoFocus={!isConsult}
            />
            {isNameAlreadyTaken ? (
                <FieldError>{t("The name is already exists")!}</FieldError>
            ) : null}
            {inputDesignation || isDesignationEmpty ? (
                <FieldError>{t("Please enter a designation")}</FieldError>
            ) : null}
            {isNonAlphanumericYavin ? (
                <FieldError>
                    {t(
                        "Designation must contain only alphanumeric characters"
                    )}
                </FieldError>
            ) : null}
        </AvGroup>
    );
}
